import { useState } from 'react';
import { FiCheck, FiCopy } from 'react-icons/fi';
import Button from '~/components/button';

import * as St from './styles';

export interface NegotiationPix {
  pixCopiaECola?: string;
  qrCodeBase64?: string;
  status?: string;
  txId?: string;
  valor?: number;
}

interface PixModalProps {
  open: boolean;
  pix: NegotiationPix | null;
  onSendEmail?: () => void;
  onClose: () => void;
}

const PixModal = ({
  open,
  pix,
  onSendEmail,
  onClose,
}: PixModalProps): JSX.Element | null => {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const code = pix?.pixCopiaECola || '';
  const rawQrCode = pix?.qrCodeBase64 || '';
  let qrCode = '';

  if (rawQrCode) {
    qrCode = rawQrCode.startsWith('data:')
      ? rawQrCode
      : `data:image/png;base64,${rawQrCode}`;
  }

  const copyCode = async () => {
    if (!code) return;

    await navigator.clipboard.writeText(code);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 3000);
  };

  return (
    <St.PixOverlay>
      <St.PixCard>
        <St.PanelTitle>Pix gerado</St.PanelTitle>
        {qrCode && <St.PixQrCode src={qrCode} alt="QR Code Pix" />}
        <St.PixCopyField>
          <St.PixCopyInput value={code} readOnly />
          <St.PixCopyButton
            type="button"
            onClick={copyCode}
            disabled={!code}
            title={copied ? 'Código copiado' : 'Copiar código'}
            aria-label={copied ? 'Código copiado' : 'Copiar código'}
            $copied={copied}
          >
            {copied ? <FiCheck /> : <FiCopy />}
          </St.PixCopyButton>
        </St.PixCopyField>
        <St.PixActions>
          <Button fullWidth outlined type="button" onClick={onSendEmail}>
            <span>Enviar por e-mail</span>
          </Button>
          <Button fullWidth type="button" onClick={onClose}>
            <span>Ok</span>
          </Button>
        </St.PixActions>
      </St.PixCard>
    </St.PixOverlay>
  );
};

export default PixModal;
